import Cropper from "react-cropper";
import Modal from "@mui/material/Modal";
import { useState, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import BusinessCards from "../../Advisor/BusinessCards.js"
import { UserIcon } from "../../Advisor/ClientIndex/Team.js";
import { postRequest, showMessage } from "../../../../config.js";
import { hasValidAdvisor } from '../../Advisor/BusinessCards.js';
import { toggleModal } from "../../../../reducers/modalReducer.js";
import TeamMemberList from "../../../../components/TeamMemberList/index.jsx";
import TeamMemberModal from "../../../../components/modals/TeamMember/index.jsx";

export default function CompanyTeamMembers({ profileClass, company, teamMembers, setEditUser, setUserAction, resendInviteMember, handleDeleteMember }) {

	const dispatch = useDispatch();
	let user = useSelector((state) => state.user);
	let modal = useSelector((state) => state.modal);
	let [selectedData, setSelectedData] = useState({});
	const [action, setAction] = useState("");
	const [memeberData, setMemberData] = useState({});
	let [hideUserIcon, setHideUserIcon] = useState(false);
	let [updateType, setUpdateType] = useState("profileImage");
	let [uploadImage, setUploadImage] = useState("");
	const [selectAll, setSelectAll] = useState(false);
	const [permissions, setPermissions] = useState({});
	const cropper = useRef(null);

	const handleUploadImage = async (e) => {
		let profile = e.target.files[0];
		if (profile && profile.size > 5 * 1024 * 1024) return showMessage("Photo Size must be less than 5MB");
		profile = await URL.createObjectURL(profile);
		setUploadImage(profile);
	};

	// Upload a team member's profile picture. Sets memberData.profile so it shows in the edit form; the picture
	// persists when the user clicks Update (the edit save at /user/editMember already sends `profile`).
	const updateProfile = async () => {
		if (cropper.current && uploadImage) {
			let imageToUpload = cropper?.current?.getCroppedCanvas()?.toDataURL();
			let res = await fetch(imageToUpload);
			let blob = await res.blob();
			const coverFile = new File([blob], "profile-image.png", { type: "image/png" });
			const response = await postRequest(`/user/upload/advisor/profile`, { attachment: [coverFile] });
			if (response && (response["code"] == 200 || response["message"])) {
				setMemberData({ ...memeberData, profile: response?.["message"] });
				setUploadImage("");
				dispatch(toggleModal({ open: "teamPopup" }));
			} else showMessage(response?.["message"] || "Failed to upload image");
		} else showMessage("Please upload image first");
	};

	// Build comprehensive permissions list (sections)
	const allPermissions = useMemo(() => {
		if (!company?.sections?.length) return [];

		// Extra modules (ABF, BFS, CDD, EHE, etc.)
		const extraModules = (company['extraModules'] && company['extraModules'].length) ? company['extraModules'].map((mod) => ({
			type: mod.type,
			_id: mod._id,
			sectionNo: mod.id,
			sectionName: mod.moduleName === 'Investment Readiness' && mod.name ? `Investment Readiness (${mod.name})` : mod.moduleName
		})) : [];

		// Investor checklist modules
		const generateChecklistModules = (company['generateChecklistModules'] && company['generateChecklistModules'].length) ? company['generateChecklistModules'].map((mod) => ({
			checklistModule: true,
			type: mod.type,
			_id: mod._id,
			sectionNo: mod.moduleKey,
			sectionName: mod.moduleName === 'Investment Readiness' ? `Investment Readiness (${mod.moduleKey})` : mod.moduleName
		})) : [];

		// Combine all permissions — hide Exit Readiness unless company testType is 'exit'
		return [...company['sections'], ...extraModules, ...generateChecklistModules]
			.filter(section => section['sectionName'] !== 'Exit Readiness' || company['testType'] === 'exit');
	}, [company?.sections, company?.extraModules, company?.generateChecklistModules]);

	const handleMemberEdit = async (member) => {
		let permissions = company?.['memberPermissions']?.[member['_id']];
		await setEditUser({ ...member, permissions });
		setUserAction('Edit');
		dispatch(toggleModal({ open: 'editUser' }));
	};

	const getMembers = async () => {
		console.log("Get Members");
	}

	const handleCompanyMember = async (member, action) => {
		if (member) {
			const isOwner = member._id && (company?.creatorId?._id === member._id || company?.creatorId === member._id);
			setMemberData({
				_id: member["_id"],
				firstName: member["firstName"],
				lastName: member["lastName"],
				email: member["email"],
				designation: member["designation"],
				isDisable: user?._id === member?._id ? false : true,
				isSuperUser: user?.["createdBy"] ? false : true,
				isOwner,
				phone: member["phone"] && member["phone"] !== undefined && member["phone"] !== 'undefined' ? member["phone"] : '+44',
				linkedIn: member["linkedIn"] ? member["linkedIn"] : '',
				profile: member["profile"] ? member["profile"] : ''
			});

			// Initialize permissions for edit mode
			if (action === "edit" && member._id) {
				if (isOwner) {
					// Owner/admin has all permissions by default
					const ownerPerms = {};
					allPermissions.forEach(section => {
						if (section.sectionNo) ownerPerms[section.sectionNo] = true;
					});
					setPermissions(ownerPerms);
					setSelectAll(true);
				} else if (company?.memberPermissions?.[member._id]) {
					const memberPerms = company.memberPermissions[member._id];
					setPermissions(memberPerms);
					const allSelected = allPermissions.length > 0 && allPermissions.every(
						section => section.sectionNo && memberPerms[section.sectionNo]
					);
					setSelectAll(allSelected);
				} else {
					setPermissions({});
					setSelectAll(false);
				}
			} else {
				setPermissions({});
				setSelectAll(false);
			}
		}
		setAction(action);
		dispatch(toggleModal({ open: "teamPopup" }));
	};

	const onModalClose = () => dispatch(toggleModal({ open: "" }));

	const handleSetMemberData = (data) => {
		setMemberData(data);
		if (!data) setSelectedData({});
	};

	return (
		<>
			<div className="df jcc fdc pr mb5rem">
				<TeamMemberList
					userType="company"
					team={teamMembers}
					user={user}
					profileClass={profileClass}
					setSelectedData={setSelectedData}
					hasValidAdvisor={hasValidAdvisor}
					showEditButton={() => !user?.["createdBy"]}
					handleEditRoute={(item) => item?.editRoute || (() => handleMemberEdit(item))}
					handleAdvisor={() => setSelectedData({ ...selectedData, hasEditButton: false })}
					setResendAdvisor={() => setSelectedData({ ...selectedData, hasEditButton: false })}
					handleCompanyMember={handleCompanyMember}
					UserIcon={UserIcon}
					company={company}
				/>
			</div>

			{/* Business Card Modal */}
			<Modal open={Object.keys(selectedData).length} onClose={() => setSelectedData({})} className="td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
				<BusinessCards
					user={user}
					company={company}
					selectedData={selectedData}
					profileClass={profileClass}
					setSelectedData={setSelectedData}
					onEditClick={(member) => handleCompanyMember(member, "edit")}
				/>
			</Modal>

			<TeamMemberModal
				userType="company"
				modal={modal}
				getAdvisors={getMembers}
				onModalClose={onModalClose}
				setUpdateType={setUpdateType}
				setUploadImage={setUploadImage}
				user={user}
				action={action}
				advisorData={memeberData}
				selectedData={memeberData}
				setSelectedData={handleSetMemberData}
				setAdvisorData={setMemberData}
				profileClass={profileClass}
				hideUserIcon={hideUserIcon}
				sections={allPermissions}
				permissions={permissions}
				setPermissions={setPermissions}
				selectAll={selectAll}
				setSelectAll={setSelectAll}
			/>

			{/* Upload Member Profile Picture — distinct key from the company-logo "uploadProfile" modal */}
			<Modal open={modal["open"] == "uploadMemberProfile"} onClose={() => dispatch(toggleModal({ open: "" }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 bsbb df fdc m1rem maw600px br10px pr">
					<div className={`top-header py1rem px2rem df jcsb aic ${profileClass}`} style={{ borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>Upload Profile Picture</h4>
						<img className="w60px" src={require(`../../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className='df fdc p3rem'>
						{uploadImage == "" ? (
							<label htmlFor="memberProfile" className="w100 bsbb bg5 br5px tac p1rem bsd bo6 bw2px cp pr upload-pic-area">
								<span className="pen fs1rem fw500 tac">Upload Photo</span>
								<br />
								<div className="">
									<input type="file" id="memberProfile" onChange={(e) => handleUploadImage(e)} accept="image/jpeg, image/jpg, image/png" />
								</div>
								<label>Max file size 5MB</label>
							</label>
						) : (
							<div className="img-box pr">
								<Cropper ref={cropper} guides={false} src={uploadImage} aspectRatio={1 / 1} className="cropper-settings" style={{ maxHeight: "500px" }} />
							</div>
						)}
						<div className="df jcse">
							<span onClick={() => { setUploadImage(""); dispatch(toggleModal({ open: "teamPopup" })); }} className="shadow bg4 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">Cancel</span>
							<span onClick={() => updateProfile()} className="shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">{uploadImage == "" ? "Upload" : "Crop & Upload"}</span>
						</div>
					</div>
				</div>
			</Modal>

		</>
	);
}
